'use strict';

function controller () {
    const ctrl = this;
    ctrl.name = 'sponsoredFinanceAd';

}

controller.$inject = [];

export default controller;
